/* eslint-disable */
// modalProps -- DatePicker 相关制定设置
// actionChange: 父级组件 回掉方法
import React, { useState, useEffect } from 'react'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'

const I2DatePicker = (props) => {
  const {
    id,
    modalProps, picker,// 组件 功能参数
    value, dateStrValue, dateOfType,// 组件 数据源
    actionChange, onChange // 请求方法
  } = props

  const handleDatePicker = (e, eStr) => {
    // ---- 初始化数据 -----
    let formatValue = e

    const formatConfig = [
      { key: 'startOf', format: +dayjs(e).startOf(picker || 'day') },
      { key: 'endOf', format: +dayjs(e).endOf(picker || 'day') },
      { key: 'defaultTime', format: +dayjs(e)}
    ]
    // ----- 处理数据 -----------
    switch (true) {
      case (!e): {
        formatValue = null
        break
      }
      // dateStrValue === true, 提交参数 为 字符串 根据 picker 类型
      case (dateStrValue): {
        formatValue = eStr
        break
      }
      // dateOfType === startOf | endOf | defaultTime,
      // 提交参数为，开始日| 结束日 去除时分秒，根据picker参数 ，或者 保留时分
      default: {
        const findKey = formatConfig.find(e => e.key === dateOfType)
        formatValue = findKey.format
        break
        // formatValue = +dayjs(e)
        break
      }
    }
    onChange(formatValue, eStr)
  }
  // 253402185600000 = 9999年12月31日
  const defaultValue = value && value !== 253402185600000 ? dayjs(value) : undefined

  return (
    <DatePicker
        // picker = 'week'
        // picker = 'month'
        // picker = 'quarter'
        // picker = 'year'
        // style={style}
        {...modalProps}
        // defaultValue={defaultValue}
        value={defaultValue}
        onChange={handleDatePicker}
        id={props.id}
      />
  )
}

export default I2DatePicker

I2DatePicker.defaultProps = {
  propsClassName: 'mode',
  propsClassSpan: '',
  modalProps: {},
  picker: undefined,
  query: {},
  dateStrValue: false,
  dateOfType: 'startOf',
  killPending: false
}